import LabSuppliersV2 from "./v2/LabSuppliers";

export default function LabSuppliers(props) {
  return <LabSuppliersV2 {...props} />;
}
